import { render } from "./VideoOverlay.vue?vue&type=template&id=50acf1ea&scoped=true"
import script from "./VideoOverlay.vue?vue&type=script&lang=js"
export * from "./VideoOverlay.vue?vue&type=script&lang=js"

import "./VideoOverlay.vue?vue&type=style&index=0&id=50acf1ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50acf1ea"]])

export default __exports__